const rightsToData = (rights = []) => rights.reduce((data, right) => {
  data[right.category] = right.value
  return data
}, {})

export const buildAccessRightsMapped = (userGroup = {}) => (
  Array.isArray(userGroup.accessRights) ? userGroup.accessRights : []
).map((item) => ({
  data: {
    name: item.treeNode?.name,
    ...rightsToData(item.rights),
  },
  key: item.treeNode?.id,
  leaf: !item.hasChildren,
  treeNode: item.treeNode,
})).filter((item) => item.key)

export const withAccessRightsMapped = (userGroup = {}) => ({
  ...userGroup,
  accessRightsMapped: buildAccessRightsMapped(userGroup),
})

export const mapOrganizationAccessRights = (organization, userGroup, accessRights = []) => {
  const container = {
    data: {
      name: organization.name,
      rights: [],
    },
    key: organization.id,
    leaf: !organization.hasChildren,
  }

  for (const key of Object.values(accessRights)) {
    container.data.rights[key] = null
  }

  const accessRight = (userGroup?.accessRightsMapped || []).find((item) => item.key === organization.id)
  if (accessRight) {
    container.data.rights = accessRight.data
  }

  return container
}

const treeContainsKey = (node, key) => {
  if (!node || !key) return false
  if (node.key === key || node.id === key) return true

  return (node.children || []).some((child) => treeContainsKey(child, key))
}

export const appendMissingAccessRightRoots = (treeItems = [], userGroup, accessRights = []) => {
  const items = [...treeItems]

  for (const accessRight of userGroup?.accessRightsMapped || []) {
    if (!items.some((item) => treeContainsKey(item, accessRight.key)) && accessRight.treeNode) {
      items.push(mapOrganizationAccessRights(accessRight.treeNode, userGroup, accessRights))
    }
  }

  return items
}
